import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import {useTranslation} from "react-i18next";
import roles from 'role'

export default function TokenList({ match }) {

    const {t} = useTranslation();

    const fields = [
        { name: t('Creation timestamp'), key: 'creationTimestamp', map: dateTimeFormatter },
        { name: t('Expiration timestamp'), key: 'expirationTimestamp', map: dateTimeFormatter },
        { name: t('User Name'), keys: ['user', 'fullName'] },
        { name: t('User Email'), keys: ['user', 'email'] },
        { name: t('Institution'), keys: ['institution', 'name'] },
        { name: t('Country'), keys: ['institution', 'country', 'name'] },
    ];

    return (
        <ListCRUD
            plural='communicationTokens'
            singular='communicationToken'
            fields={fields}
            match={match}
            disableViewButton
            disableEditButton
            canNew={[roles.NATIONAL_AUTHORITY]}
        />
    );
};